<script setup lang="ts"></script>

<template>
  <div class="min-w-[300px] min-h-[300px] flex flex-col justify-center items-center">
    Component: CommunityTool
  </div>
</template>

<style scoped></style>
